'use client'

import { useState } from 'react'
import { Button } from '@astryxdesign/core/Button'
import { TextInput } from '@astryxdesign/core/TextInput'
import { TextArea } from '@astryxdesign/core/TextArea'
import { submitGeneralFeedback } from '@/app/actions/productFeedback'
import { captureAnalyticsEvent } from '@/utils/analytics'

export default function ContactForm() {
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [message, setMessage] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [status, setStatus] = useState(null)

  async function handleSubmit(event) {
    event.preventDefault()
    setIsSubmitting(true)
    setStatus(null)

    const trimmedName = name.trim()
    const trimmedEmail = email.trim()
    const trimmedMessage = message.trim()
    const composedMessage = [
      trimmedName ? `Name: ${trimmedName}` : '',
      trimmedEmail ? `Email: ${trimmedEmail}` : '',
      trimmedMessage,
    ].filter(Boolean).join('\n\n')

    let result
    try {
      result = await submitGeneralFeedback({
        contactEmail: trimmedEmail,
        pagePath: '/contact',
        topic: 'Contact form',
        message: composedMessage,
        source: 'contact_page',
      })
    } catch (error) {
      setStatus({
        type: 'error',
        text: error?.message || 'We could not send your message. Please try again.',
      })
      setIsSubmitting(false)
      return
    }

    if (result?.error) {
      setStatus({ type: 'error', text: result.error })
      setIsSubmitting(false)
      return
    }

    captureAnalyticsEvent('contact_form_submitted', {
      event_category: 'feedback',
      has_contact_email: Boolean(trimmedEmail),
    })

    setStatus({
      type: 'success',
      text: result?.warning || 'Thanks. Your message was sent. We will reply by email within 1-2 business days.',
    })
    setName('')
    setEmail('')
    setMessage('')
    setIsSubmitting(false)
  }

  return (
    <form className="contact-form" onSubmit={handleSubmit}>
      <TextInput
        label="Name"
        value={name}
        onChange={setName}
        autoComplete="name"
      />

      <TextInput
        type="email"
        label="Email"
        value={email}
        onChange={setEmail}
        autoComplete="email"
        isRequired
      />

      <TextArea
        label="Message"
        value={message}
        onChange={setMessage}
        rows={7}
        isRequired
      />

      {status ? (
        <div
          className={`contact-form-status contact-form-status--${status.type}`}
          role="status"
        >
          {status.text}
        </div>
      ) : null}

      <div className="panel-actions contact-form-actions">
        <Button
          type="submit"
          variant="primary"
          label={isSubmitting ? 'Sending...' : 'Send message'}
          isDisabled={isSubmitting}
        />
      </div>
      <p className="contact-privacy-note">
        We will only use your details to respond to you. We never sell your information.
      </p>
    </form>
  )
}
